// Coarse risk map of mainland Portugal for the landing hero.
//
// Downsampled offline from the live model output (data.tutela.land/country.json,
// 88 527 cells at 1 km) into a 20-column, aspect-correct grid. Each character is
// one bin: '.' = no data (sea/offshore), '0'..'3' = risk level
// (0 Low, 1 Moderate, 2 High, 3 Extreme). The shape is the real continental
// footprint; the colours are a representative real snapshot.
//
// Snapshot: for_date 2026-07-01, model seasonal-ensemble:be23+lst1.
// Regenerate with scripts/build_landing_grid.py after a notable pattern change.

export const PT_GRID_COLS = 20;

export const PT_RISK_GRID: string[] = [
  '.....1000...........',
  '...012200011..0000..',
  '...1123200110000000.',
  '...11232211111000000',
  '....0012310010000000',
  '....0012312210000000',
  '....0133311100000000',
  '....01233300000000..',
  '.....123321000000...',
  '....0111222110000...',
  '....0011001010000...',
  '....0001011100000...',
  '....0000011111000...',
  '....0000000001000...',
  '...00000000011000...',
  '...0000000001000....',
  '...0000000000000....',
  '...0000000000000....',
  '..00000000000000....',
  '..00000000000000....',
  '.000000000000.......',
  '00000000000000......',
  '00000000000000......',
  '000000000000000.....',
  '0000000000000000....',
  '0000000000000000....',
  '000000000000000.....',
  '00000000000000......',
  '.0000000000000......',
  '.0000000000000......',
  '....00000000000.....',
  '....000000000000....',
  '...0000000000000....',
  '...00000000000......',
  '....0000000000......',
  '....000000000.......',
  '....000000000.......',
  '...0000000000.......',
  '...0000000000.......',
  '...0000000000.......',
  '...00.000000........',
];
